import React, { ChangeEvent, useState } from "react";
import Input from "../Inputs";
import { CONSTANTS } from "../../constants/Constants";
import Textarea from "../Textarea";
import Button from "../Buttons";
import Select from "../Select";
import moment from "moment";
import profilePlaceHolder from "../../assets/images/profile_image_placeholder.png"
interface BasicInfoProps {
  availabilityStatus?: string;
  availableFrom: string;
  country?: string;
  city?: string;
  name?: string;
  title?: string;
  description?: string;
  profileImage?: string;
  displayName?: string;
  yearsOfExperience?: string;
  skills?: { name: string; rating: number }[];
  techStack?: { name: string }[];
  changeHandler: (e: ChangeEvent, index?: number) => void;
  addNewRow: (rowFor: string) => void;
  removeRow: (index: number, rowFor: string) => void;
  countryOptions: {}[];
  cityOptions: {}[];
  changeLocationHandler: (e: ChangeEvent<HTMLSelectElement>) => void;
  isDateVisible?: boolean;
  setIsDateVisible: (state: boolean) => void;
  availiblityHandler: (availableAt: string, date?: string) => void;
  cityError: string;
  displayNameMessage: { message: string; success: boolean };
  displayNameHandler: (e: Event) => void;
}
const BasicInformation: React.FC<BasicInfoProps> = ({
  availabilityStatus,
  availableFrom,
  country,
  city,
  name,
  title,
  description,
  profileImage,
  yearsOfExperience,
  skills,
  techStack,
  changeHandler,
  addNewRow,
  removeRow,
  countryOptions,
  changeLocationHandler,
  cityOptions,
  isDateVisible,
  setIsDateVisible,
  availiblityHandler,
  cityError,
  displayName,
  displayNameMessage,
  displayNameHandler,
}) => {
  const [selectedButton, setSelectedButton] = useState<any>(availabilityStatus ||  CONSTANTS.NOT_AVAILABLE_CODE_TXT);

  const handleStatusClick = (status: string, event?: Event) => {
    if (status === CONSTANTS.AVAILABLE_ON_DATE_CODE_TXT) {
      setIsDateVisible(true);
    } else {
      setIsDateVisible(false);
    }
    if (event) {
      let target = event.target as HTMLInputElement;
      let value = target.value as string;
      availiblityHandler(status, value);
    } else availiblityHandler(status);
    setSelectedButton(status);
  };

  return (
    <div className="p-4 flex-1">
      <div className="bg-white lg:w-100 lg:flex gap-3">
        <div>
          <div className="w-fit relative items-center mb-6">
            <img
              src={profileImage || profilePlaceHolder}
              alt="Profile"
              className="rounded-full w-20 h-20 object-cover"
            />
            <input
              onChange={changeHandler}
              name={
                CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.IMAGE_FILE
              }
              id="update_profile_image"
              className="hidden"
              type="file"
            />
            <label
              htmlFor="update_profile_image"
              className="cursor-pointer text-sm"
            >
              <div className="absolute right-[5px] bottom-[0px] flex items-center justify-center text-center text-white w-[20px] h-[20px] bg-primary rounded-full">
                <div className="text-[18px]">&#43;</div>
              </div>
            </label>
          </div>

          <div className="sm:block md:grid grid-cols-2 gap-3">
            <div>
              <label className="block text-sm font-medium">
                {CONSTANTS.NAME_TXT}
                <span className="text-error mr-1">*</span>
              </label>
              <Input
                input_name={
                  CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.NAME
                }
                value={name}
                placeholder={CONSTANTS.NAME_TXT}
                change_handler={changeHandler}
              />
            </div>
            <div className="mt-2 md:mt-0">
              <label className="block text-sm font-medium">
                {CONSTANTS.TITLE_TXT}
                <span className="text-error mr-1">*</span>
              </label>
              <Input
                input_name={
                  CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.TITLE
                }
                value={title}
                placeholder={CONSTANTS.TITLE_TXT}
                change_handler={changeHandler}
              />
            </div>
            <div className="mt-2 md:mt-0">
              <label className="block text-sm font-medium">
                {CONSTANTS.DISPLAY_NAME_TXT}
                <span className="text-error mr-1">*</span>
              </label>
              <Input
                input_name={
                  CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS
                    .DISPLAY_NAME
                }
                value={displayName}
                placeholder={CONSTANTS.EXPERIENCE_YEARS}
                change_handler={changeHandler}
                on_blur={displayNameHandler}
              />
              <small
                className={
                  displayNameMessage?.success ? "text-primary" : "text-error"
                }
              >
                {displayNameMessage.message}
              </small>
            </div>
            <div className="mt-2 md:mt-0">
              <label className="block text-sm font-medium">
                {CONSTANTS.EXPERIENCE_YEARS}
              </label>
              <Input
                input_name={
                  CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS
                    .YEARS_OF_EXPERIENCE
                }
                value={yearsOfExperience}
                placeholder={CONSTANTS.EXPERIENCE_YEARS}
                change_handler={changeHandler}
              />
            </div>
            <div className="mt-2 md:mt-0">
              <label className="block text-sm font-medium">
                {CONSTANTS.COUNTRY_TXT}
              </label>
              <Select
                name={CONSTANTS.COUNTRY_TXT}
                options={countryOptions}
                value={country}
                handle_change={(e: ChangeEvent<HTMLSelectElement>) =>
                  changeLocationHandler(e)
                }
                other_classes="rounded-md"
              />
            </div>
            <div className="mt-2 md:mt-0">
              <label className="block text-sm font-medium">
                {CONSTANTS.CITY_TXT}
              </label>
              <Select
                name={
                  CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.LOCATION_ID
                }
                options={cityOptions}
                value={city}
                handle_change={(e: ChangeEvent<HTMLSelectElement>) =>
                  changeLocationHandler(e)
                }
                other_classes="rounded-md"
              />
              <small className="text-error">{cityError}</small>
            </div>
            <div className="mt-2 md:mt-0">
              <label className="block text-sm font-medium">
                {CONSTANTS.AVAILABLE_STATUS}
              </label>
              <div className="flex mt-1 border border-1 rounded-full overflow-hidden">
                {[
                  CONSTANTS.NOT_AVAILABLE_CODE_TXT,
                  CONSTANTS.AVAILABILITY_IMMEDIATELY_CODE_TXT,
                  CONSTANTS.AVAILABLE_ON_DATE_CODE_TXT,
                ].map((status) => (
                  <Button
                    key={status}
                    other_classes={`border border-1 !rounded-none px-3 py-1 !h-12 ${selectedButton !== status ? "bg-transparent" : ""}`}
                    type={selectedButton === status ? "primary" : "secondary"}
                    btn_label={
                      status === CONSTANTS.NOT_AVAILABLE_CODE_TXT
                        ? CONSTANTS.UNAVAILABLE_TXT
                        : status === CONSTANTS.AVAILABILITY_IMMEDIATELY_CODE_TXT
                        ? CONSTANTS.IMMEDIATELY_TXT
                        : CONSTANTS.ON_DATE_TXT
                    }
                    on_click_handler={() => handleStatusClick(status)}
                  />
                ))}
              </div>

              {isDateVisible && (
                <Input
                  value={
                    availableFrom
                      ? moment(availableFrom).format("YYYY-MM-DD")
                      : ""
                  }
                  type="date"
                  input_name={
                    CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS
                      .AVAILABILITY_STATUS
                  }
                  change_handler={(e: Event) =>
                    handleStatusClick(CONSTANTS.AVAILABLE_ON_DATE_CODE_TXT, e)
                  }
                  other_classes="text-sm mt-3"
                  min={moment().format("YYYY-MM-DD")}
                />
              )}
            </div>
            <div className="col-span-2 mt-2 md:mt-0">
              <label className="block text-sm font-medium">
                {CONSTANTS.DESCRIPTION_TXT}
              </label>
              <Textarea
                name={
                  CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.DESCRIPTION
                }
                change_handler={changeHandler}
                placeholder={CONSTANTS.DESCRIPTION_TXT}
                value={description || ""}
                maxLength={500}
              />
              <small className="flex justify-end text-gray-500 mt-1">
                {CONSTANTS.MAXIMUM_LENGTH_DESCRIPTION_TXT} {500}
              </small>
            </div>
          </div>
        </div>
        <div className="lg:w-2/6">
          <div className="mt-6">
            <h3 className="font-medium mb-2">
              {CONSTANTS.TECHSTACK_HEADING_TXT}
            </h3>
            {techStack?.map((tech, index) => (
              <div key={index} className="flex gap-2 items-center">
                <Input
                  input_name={
                    CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS
                      .RESOURCE_TAGS
                  }
                  value={tech.name}
                  other_classes={"mt-2 flex-1"}
                  change_handler={(e: any) => changeHandler(e, index)}
                />
                <button
                  type="button"
                  className="text-error hover:text-error-dark"
                  onClick={() =>removeRow(index,CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS
                        .RESOURCE_TAGS
                    )
                  }
                >
                  ✖
                </button>
              </div>
            ))}
            <Button
              type={"secondary"}
              on_click_handler={() =>addNewRow(
                  CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS
                    .RESOURCE_TAGS
                )
              }
              btn_label={CONSTANTS.ADD_ROW_TXT}
              other_classes="mt-2 !rounded"
            />
          </div>
          <div className="mt-6">
            <h3 className="font-medium mb-2">{CONSTANTS.SKILLS_HEADING_TXT}</h3>
            {skills?.map((skill, index) => (
              <div key={index} className="flex gap-2 items-center">
                <Input
                  input_name={
                    CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS
                      .RESOURCE_SKILLS
                  }
                  type={"text"}
                  change_handler={(e: any) => changeHandler(e, index)}
                  value={skill.name}
                />
                <Input
                  input_name={
                    CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS
                      .RESOURCE_SKILLS
                  }
                  type={"number"}
                  value={skill.rating}
                  change_handler={(e: any) => changeHandler(e, index)}
                  other_classes={"!w-1/4 p-2 mt-1"}
                  min={0}
                  max={10}
                />
                <button
                  type="button"
                  className="text-error hover:text-error-dark"
                  onClick={() =>removeRow(index,
                      CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS
                        .RESOURCE_SKILLS
                    )
                  }
                >
                  ✖
                </button>
              </div>
            ))}
            <Button
              type={"secondary"}
              on_click_handler={() =>addNewRow(
                  CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS
                    .RESOURCE_SKILLS
                )
              }
              btn_label={CONSTANTS.ADD_ROW_TXT}
              other_classes="mt-2 !rounded"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicInformation;
